import { rem } from 'polished'

// Shared layout breakpoints for the drawer room cards (FlashRoomCard /
// DrawerBedbankRoomCard). These drive the container queries that switch the
// price + action area between its inline and stacked layouts.

/**
 * Container width (px) at/above which a room rate has enough room to show
 * pricing beside the fixed-width booking actions. Below this, keep the action
 * below pricing so neither column is pushed out of the drawer.
 */
export const INLINE_PRICE_ACTIONS_BREAKPOINT = 900
/** Container width (px) at/above which room cards switch back to image/content columns. */
export const ROOM_CARD_HORIZONTAL_BREAKPOINT = 640
/** Min width (px) for the rate details column in the inline layout. */
export const INLINE_RATE_DETAILS_MIN_WIDTH = 240
/** Width (px) of the price + actions block in the stacked layout. */
export const STACKED_PRICE_ACTIONS_WIDTH = 304
/** Width (px) of the action buttons column in the inline layout. */
export const INLINE_ACTION_BUTTONS_WIDTH = 260

// The hotel listing renders in the resizable right panel as well as in a modal, so
// it is regularly much narrower than the viewport. Its tiles and search fields
// follow the width of the listing itself rather than the screen size.

/**
 * Drawer content width (px) at/above which hotel tiles use their image/content
 * columns and the search fields use their desktop dropdowns. Below it the tile
 * price column (220px) no longer fits beside the 300px image.
 */
export const HOTEL_DRAWER_WIDE_LAYOUT_BREAKPOINT = 640
/** Drawer content width (px) below which hotel details hide breadcrumbs and use the full-width carousel. */
export const HOTEL_DETAIL_COMPACT_LAYOUT_BREAKPOINT = 550
/**
 * Drawer width (px) at/above which a hotel tile has enough room to show its
 * price details beside the fixed-width View offer action. Between this and the
 * wide-layout breakpoint, the tile remains horizontal but its price/action
 * area stacks to avoid squeezing the price column.
 */
export const HOTEL_DRAWER_INLINE_PRICE_ACTIONS_BREAKPOINT = 900
/** Declared by the hotel drawer content wrapper; queried by anything sized against it. */
export const HOTEL_DRAWER_CONTENT_CONTAINER_NAME = 'hotel-drawer-content'
export const hotelDrawerWideLayoutQuery = `@container ${HOTEL_DRAWER_CONTENT_CONTAINER_NAME} (min-width: ${rem(HOTEL_DRAWER_WIDE_LAYOUT_BREAKPOINT)})`
export const hotelDrawerInlinePriceActionsQuery = `@container ${HOTEL_DRAWER_CONTENT_CONTAINER_NAME} (min-width: ${rem(HOTEL_DRAWER_INLINE_PRICE_ACTIONS_BREAKPOINT)})`

export const DEFAULT_OCCUPANCIES: Array<App.Occupants> = [{ adults: 2 }]
export const HOTEL_DRAWER_MAX_GUESTS = 12
